module.exports = __webpack_public_path__ + "profile.4efeec85367895e536de20b147998d75.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/font-icons/profile.svg
// module id = 702
// module chunks = 7